import {
  setLoader,
  unSetLoader,
  setErrorMessage,
  showSnackbar,
} from "store/actions/appActions";
import { billing } from "store/requests";

export const getPatientInsuranceList = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getPatientInsuranceList",
        payload,
        addUserName: true,
      });
      return data.success;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const getInsuranceDetails = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/getInsuranceDetails",
        payload,
        addUserName: true,
      });
      dispatch(unSetLoader());
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
      dispatch(unSetLoader());
    }
  };
};

export const updateEncounterInsEligDetails = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/updateEncounterInsEligDetails",
        payload,
        addUserName: false,
      });
      dispatch(unSetLoader());
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
      dispatch(unSetLoader());
    }
  };
};

export const addInsuranceDetails = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      const { data } = await billing({
        url: "/addInsuranceDetails",
        payload,
        addUserName: true,
      });
      dispatch(unSetLoader());
      return data;
    } catch (error) {
      const { data } = error.response;
      if (data?.error?.includes("Duplicate entry")) {
        dispatch(
          setErrorMessage(
            "The insurance ID Number is already used. Please use a different insurance ID number",
          ),
        );
      } else if (data && data.hasOwnProperty("Error")) {
        dispatch(setErrorMessage(data.Error));
      } else {
        dispatch(
          setErrorMessage(error?.response?.data?.error || error.message),
        );
      }
      dispatch(unSetLoader());
    }
  };
};

export const updateInsuranceDetails = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/updateInsuranceDetails",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      const { data } = error.response;
      if (data && data?.Error) dispatch(setErrorMessage(data.Error));
      else
        dispatch(
          setErrorMessage(error?.response?.data?.error || error.message),
        );
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const deleteInsuranceDetails = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/deleteInsuranceDetails",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      const { data } = error.response;
      if (data && data.hasOwnProperty("Error"))
        dispatch(setErrorMessage(data.Error));
      else
        dispatch(
          setErrorMessage(error?.response?.data?.error || error.message),
        );
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const verifyInsurance = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let response = await billing({
        url: "/claimmd/checkClaimEligibility",
        payload,
        addUserName: true,
      });
      if (response.data.elig_verification_status === "Fail") {
        dispatch(
          showSnackbar(
            "Verification Fail:" +
              " " +
              (response.data?.error?.error_mesg ||
                response.data?.elig?.error[0]?.error_mesg ||
                "Failed to verify insurance"),
            10000,
          ),
        );
      } else if (response.data.elig_verification_status === "Success") {
        const benefitDetails = {
          benefitsArray: response.data.elig.benefit,
          benefitData: response.data.elig,
        };
        return benefitDetails;
      }
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const updateChargeEntryInsurances = (payload) => {
  return async (dispatch, store) => {
    try {
      dispatch(setLoader());
      const { data } = await billing({
        url: "/updateChargeEntryInsurances",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      if (error?.response?.data) {
        const { data } = error.response;
        if (data && data.hasOwnProperty("Error"))
          dispatch(setErrorMessage(data.Error));
        else
          dispatch(
            setErrorMessage(error?.response?.data?.error || error.message),
          );
      }
    } finally {
      dispatch(unSetLoader());
    }
  };
};
